import { MinusCircleOutlined } from '@ant-design/icons'
import { Form, Input, DatePicker, Col, Row, Button, Checkbox } from 'antd'
import { FC } from 'react'
import { CustomFormInstance } from '../../../../types'
import { CompositionForm, SharedValues } from '../types'

type Props = {
    form: CustomFormInstance<CompositionForm>
}

const CrossReferenceAndReletedApplication: FC<Props> = ({ form }) => {
    return (
        <>
            <Form.Item
                name={['backgroundInvention', 'notSet']}
                valuePropName="checked"
            >
                <Checkbox>Not applicable</Checkbox>
            </Form.Item>
            {!form.getFieldValue(['backgroundInvention', 'notSet']) ? (
                <>
                    <Form.Item
                        label="If you wish to claim priority to a U.S. nonprovisional patent application, please discuss with a patent professional.
                        For informational purposes only, you may provide the application number and date of submission for discussion with a patent professional."
                    >
                        <Form.List
                            name={[
                                'backgroundInvention',
                                'nonprovisionalNumbers',
                            ]}
                            rules={[
                                {
                                    validator: async (_, components) => {
                                        const provisionalNumbers =
                                            form.getFieldValue<
                                                SharedValues['backgroundInvention']['provisionalNumbers']
                                            >([
                                                'backgroundInvention',
                                                'provisionalNumbers',
                                            ])
                                        if (
                                            (components === undefined ||
                                                components?.length === 0) &&
                                            (provisionalNumbers === undefined ||
                                                provisionalNumbers.length === 0)
                                        )
                                            throw new Error(
                                                'At least one number!'
                                            )
                                    },
                                },
                            ]}
                        >
                            {(fields, { add, remove }, errors) => (
                                <>
                                    {fields.map((field) => (
                                        <Form.Item
                                            shouldUpdate={(
                                                prevValues,
                                                curValues
                                            ) =>
                                                prevValues.commonName
                                                    ?.notSet !==
                                                curValues.commonName?.notSet
                                            }
                                            key={field.key}
                                        >
                                            <Row gutter={[12, 0]}>
                                                <Col span={12}>
                                                    <Form.Item
                                                        {...field}
                                                        name={[
                                                            field.name,
                                                            'number',
                                                        ]}
                                                        fieldKey={[
                                                            field.fieldKey as number,
                                                            'number',
                                                        ]}
                                                        hasFeedback
                                                        rules={[
                                                            {
                                                                required:
                                                                    !form.getFieldValue(
                                                                        [
                                                                            'backgroundInvention',
                                                                            'notSet',
                                                                        ]
                                                                    ) ?? true,
                                                                message:
                                                                    'Number is required',
                                                            },
                                                        ]}
                                                    >
                                                        <Input type="text" />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={10}>
                                                    <Form.Item
                                                        {...field}
                                                        name={[
                                                            field.name,
                                                            'date',
                                                        ]}
                                                        fieldKey={[
                                                            field.fieldKey as number,
                                                            'date',
                                                        ]}
                                                        hasFeedback
                                                        rules={[
                                                            {
                                                                required:
                                                                    !form.getFieldValue(
                                                                        [
                                                                            'backgroundInvention',
                                                                            'notSet',
                                                                        ]
                                                                    ) ?? true,
                                                                message:
                                                                    'Date of submission is required',
                                                            },
                                                        ]}
                                                    >
                                                        <DatePicker
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                            format="MM/DD/YYYY"
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col
                                                    style={{
                                                        textAlign: 'center',
                                                        paddingTop: '.4rem',
                                                    }}
                                                    span={2}
                                                >
                                                    {fields.length > 0 ? (
                                                        <MinusCircleOutlined
                                                            className="dynamic-delete-button"
                                                            onClick={() =>
                                                                remove(
                                                                    field.name
                                                                )
                                                            }
                                                            style={{
                                                                color: '#f00',
                                                                fontSize:
                                                                    '1.2rem',
                                                            }}
                                                        />
                                                    ) : null}
                                                </Col>
                                            </Row>
                                        </Form.Item>
                                    ))}

                                    <Form.ErrorList errors={errors.errors} />
                                    <Form.Item>
                                        <Button
                                            type="dashed"
                                            onClick={() => add()}
                                            block
                                        >
                                            Add nonprovisional number
                                        </Button>
                                    </Form.Item>
                                </>
                            )}
                        </Form.List>
                    </Form.Item>
                    <Form.Item
                        label="If you wish to claim priority to a U.S. provisional patent application, please discuss with a patent professional.
                        For informational purposes only, you may provide the application number and date of submission for discussion with a patent professional."
                    >
                        <Form.List
                            name={['backgroundInvention', 'provisionalNumbers']}
                            rules={[
                                {
                                    validator: async (_, components) => {
                                        const nonprovisionalNumbers =
                                            form.getFieldValue<
                                                SharedValues['backgroundInvention']['nonprovisionalNumbers']
                                            >([
                                                'backgroundInvention',
                                                'nonprovisionalNumbers',
                                            ])
                                        if (
                                            (components === undefined ||
                                                components?.length === 0) &&
                                            (nonprovisionalNumbers ===
                                                undefined ||
                                                nonprovisionalNumbers.length ===
                                                    0)
                                        )
                                            throw new Error(
                                                'At least one number!'
                                            )
                                    },
                                },
                            ]}
                        >
                            {(fields, { add, remove }, errors) => (
                                <>
                                    {fields.map((field) => (
                                        <Form.Item
                                            shouldUpdate={(
                                                prevValues,
                                                curValues
                                            ) =>
                                                prevValues.commonName
                                                    ?.notSet !==
                                                curValues.commonName?.notSet
                                            }
                                        >
                                            <Row gutter={[12, 0]}>
                                                <Col span={12}>
                                                    <Form.Item
                                                        {...field}
                                                        name={[
                                                            field.name,
                                                            'number',
                                                        ]}
                                                        fieldKey={[
                                                            field.fieldKey as number,
                                                            'number',
                                                        ]}
                                                        rules={[
                                                            {
                                                                required:
                                                                    !form.getFieldValue(
                                                                        [
                                                                            'backgroundInvention',
                                                                            'notSet',
                                                                        ]
                                                                    ) ?? true,
                                                                message:
                                                                    'Common name is required',
                                                            },
                                                        ]}
                                                        hasFeedback
                                                    >
                                                        <Input type="text" />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={10}>
                                                    <Form.Item
                                                        {...field}
                                                        name={[
                                                            field.name,
                                                            'date',
                                                        ]}
                                                        fieldKey={[
                                                            field.fieldKey as number,
                                                            'date',
                                                        ]}
                                                        rules={[
                                                            {
                                                                required:
                                                                    !form.getFieldValue(
                                                                        [
                                                                            'backgroundInvention',
                                                                            'notSet',
                                                                        ]
                                                                    ) ?? true,
                                                                message:
                                                                    'Common name is required',
                                                            },
                                                        ]}
                                                        hasFeedback
                                                    >
                                                        <DatePicker
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                            format="MM/DD/YYYY"
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col
                                                    style={{
                                                        textAlign: 'center',
                                                        paddingTop: '.4rem',
                                                    }}
                                                    span={2}
                                                >
                                                    {fields.length > 0 ? (
                                                        <MinusCircleOutlined
                                                            className="dynamic-delete-button"
                                                            onClick={() =>
                                                                remove(
                                                                    field.name
                                                                )
                                                            }
                                                            style={{
                                                                color: '#f00',
                                                                fontSize:
                                                                    '1.2rem',
                                                            }}
                                                        />
                                                    ) : null}
                                                </Col>
                                            </Row>
                                        </Form.Item>
                                    ))}

                                    <Form.ErrorList errors={errors.errors} />
                                    <Form.Item>
                                        <Button
                                            type="dashed"
                                            onClick={() => add()}
                                            block
                                        >
                                            Add provisional number
                                        </Button>
                                    </Form.Item>
                                </>
                            )}
                        </Form.List>
                    </Form.Item>
                </>
            ) : (
                <></>
            )}
            <Form.Item
                name={['backgroundInvention', 'custom']}
                valuePropName="checked"
            >
                <Checkbox>
                    Check the box if there any advantages or desirable
                    characteristics that your invention can provide but existing
                    options or alternatives fail to provide.
                </Checkbox>
            </Form.Item>
        </>
    )
}

export default CrossReferenceAndReletedApplication
